
import { onMounted, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import BackTo from '@/components/block/BackTo.vue'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'DocumentRequestDetail',

  props: {
    detail: Object,
    loading: {
      type: Boolean,
      default: true
    }
  },

  components: {
    HeadingLv1,
    MypageContents,
    HeadingLv3,
    Button,
    PreviewPairData,
    BackTo,
    Loader
  },

  setup(props, context) {
    const route = useRoute()
    onMounted(() => {
      const id = route.params.id
      if (id.indexOf('_') == -1) {
        context.emit('get-detail-page', id)
      } else {
        const hospitalID = (id as string).split('_')[0]
        context.emit('get-detail-page-s', hospitalID)
      }
    })
  }
})
